// extracted by mini-css-extract-plugin
export default {"landscapeLock":"landscapeLock_landscapeLock__vPL6E","inner":"landscapeLock_inner__UlGZR","logo":"landscapeLock_logo__YYtXZ","phone":"landscapeLock_phone__OPFDd"};